import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-care-blue text-white">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <Link to="/" data-testid="footer-logo">
              <img src="/logo-wordmark-white.png" alt="PrimeShift Group" className="h-8 w-auto mb-4" />
            </Link>
            <p className="text-white/70 text-sm leading-relaxed">
              PrimeShift Group — Aged Care Division. Providing quality Personal Care Assistants for permanent positions in aged care homes across Sydney.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <div className="space-y-2">
              <Link to="/" className="block text-white/70 hover:text-care-green transition-colors duration-200">Home</Link>
              <Link to="/clients" className="block text-white/70 hover:text-care-green transition-colors duration-200">Request PCAs</Link>
              <Link to="/careers" className="block text-white/70 hover:text-care-green transition-colors duration-200">Careers</Link>
              <Link to="/about" className="block text-white/70 hover:text-care-green transition-colors duration-200">About</Link>
              <Link to="/contact" className="block text-white/70 hover:text-care-green transition-colors duration-200">Contact</Link>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Phone size={18} />
                <a href="tel:+61281889656" className="text-white/70 hover:text-care-green transition-colors duration-200">(02) 8188 9656</a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail size={18} />
                <a href="mailto:info@primeshiftgroup.com.au" className="text-white/70 hover:text-care-green transition-colors duration-200" data-testid="footer-email-link">info@primeshiftgroup.com.au</a>
              </div>
              <div className="flex items-center space-x-3">
                <MapPin size={18} />
                <span className="text-white/70">Sydney, Australia</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 mt-8 pt-8">
          <p className="text-white/50 text-sm leading-relaxed text-center max-w-4xl mx-auto mb-6">
            PrimeShift Group provides professional Personal Care Assistant recruitment services for aged care homes and residential facilities across Sydney. Aged care providers rely on PrimeShift Group for dependable, compassionate and fully screened PCA placements.
          </p>
          <p className="text-center text-white/40 text-sm">
            &copy; PrimeShift Group. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
